<template>
  <div class="riddle-card">
    <div class="question-section">
      <div class="question-icon">❓</div>
      <h2 class="question-text">{{ riddle.question }}</h2>
    </div>
    
    <div class="answer-section">
      <transition name="answer-reveal" mode="out-in">
        <div v-if="showAnswer" class="answer-content">
          <div class="answer-icon">💡</div>
          <p class="answer-text">{{ riddle.answer }}</p>
        </div>
        <div v-else class="answer-placeholder">
          <p class="placeholder-text">点击下方按钮查看答案</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RiddleCard',
  props: {
    riddle: {
      type: Object,
      required: true
    },
    showAnswer: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style src="@/styles/RiddleCard.css"></style>
